var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7123 4.8185C9.6619 2.76806 6.33811 2.76806 4.28767 4.8185C2.23723 6.86894 2.23723 10.1927 4.28767 12.2432C6.33811 14.2936 9.6619 14.2936 11.7123 12.2432C13.7628 10.1927 13.7628 6.86894 11.7123 4.8185ZM12.773 3.75784C10.1368 1.12161 5.86323 1.12161 3.22701 3.75784C0.590781 6.39407 0.590781 10.6676 3.22701 13.3038C5.86323 15.9401 10.1368 15.9401 12.773 13.3038C15.4092 10.6676 15.4092 6.39407 12.773 3.75784ZM5.25 9.86417C5.25 9.44995 5.58579 9.11417 6 9.11417H10C10.4142 9.11417 10.75 9.44995 10.75 9.86417C10.75 10.2784 10.4142 10.6142 10 10.6142H6C5.58579 10.6142 5.25 10.2784 5.25 9.86417ZM6 6.4475C5.58579 6.4475 5.25 6.78329 5.25 7.1975C5.25 7.61171 5.58579 7.9475 6 7.9475H10C10.4142 7.9475 10.75 7.61171 10.75 7.1975C10.75 6.78329 10.4142 6.4475 10 6.4475H6Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopics);
export default __webpack_public_path__ + "static/media/topics.6228799c36e3e33bdfd697dffd3af3f0.svg";
export { ForwardRef as ReactComponent };